import {
  LicenseClient,
  LicenseDetailDTO,
  LicenseValidatorPublicKey,
  ChallengeDto,
  ProductEditionDTO,
  SignedChallengeDTO,
  VerifyChallengeResponse,
} from 'business/models/Models';
import ModelFactory from 'business/models/ModelFactory';
import BaseService from 'business/services/BaseService';

export default class LicenseService extends BaseService {
  async getHybridLicenseList(showAllSeats: boolean = false): Promise<LicenseDetailDTO[]> {
    const lic: LicenseClient = ModelFactory(LicenseClient, false, true);
    const licList: LicenseDetailDTO[] = await lic.getHybridLicenseList(showAllSeats);
    return licList;
  }

  async setHybridPickedLicense(): Promise<boolean> {
    return true;
  }

  async getLicenseDetails(showAllSeats: boolean = false): Promise<LicenseDetailDTO> {
    const lic: LicenseClient = ModelFactory(LicenseClient, false, true);
    const ld: LicenseDetailDTO = await lic.getLicenseDetail(showAllSeats);
    return ld;
  }

  async getProductEdition(): Promise<ProductEditionDTO> {
    const lic: LicenseClient = ModelFactory(LicenseClient, false, true);
    const ld: ProductEditionDTO = await lic.getProductEdition();
    return ld;
  }

  async endLicenseSession(): Promise<string> {
    const lic: LicenseClient = ModelFactory(LicenseClient, false, true);
    await lic.endLicenseSession('session');
    return '';
  }

  async isSeatRegistered(): Promise<boolean> {
    const licenseClient: LicenseClient = ModelFactory(LicenseClient, false, true);
    return await licenseClient.isSeatRegistered();
  }

  async getChallenge(publicKey: LicenseValidatorPublicKey): Promise<ChallengeDto> {
    const licenseClient: LicenseClient = ModelFactory(LicenseClient, false, true);
    return await licenseClient.getChallenge(publicKey);
  }

  async verifyChallenge(
    signedChallenge: SignedChallengeDTO,
  ): Promise<VerifyChallengeResponse> {
    const licenseClient: LicenseClient = ModelFactory(LicenseClient, false, true);
    return await licenseClient.verifyChallenge(signedChallenge);
  }
}
